// FassalkartAI - 404 Page

import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowBack } from '@mui/icons-material';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      textAlign: 'center', p: 4, bgcolor: 'background.default',
    }}>
      <Box component="img" src="/logo192.png" alt="FassalkartAI" sx={{ width: 100, height: 100, objectFit: 'contain', mb: 2, animation: 'bounce 2s infinite', '@keyframes bounce': { '0%,100%': { transform: 'translateY(0)' }, '50%': { transform: 'translateY(-10px)' } } }} />
      <Typography variant="h1" fontWeight={700} color="primary" sx={{ fontSize: { xs: '4rem', md: '6rem' }, lineHeight: 1 }}>
        404
      </Typography>
      <Typography variant="h5" fontWeight={600} sx={{ mt: 2 }}>
        यह पेज नहीं मिला
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mt: 1, mb: 4, maxWidth: 360 }}>
        The page you're looking for doesn't exist or has been moved.
      </Typography>
      <Stack direction="row" spacing={2}>
        <Button variant="outlined" startIcon={<ArrowBack />} onClick={() => navigate(-1)}>
          Go Back
        </Button>
        <Button variant="contained" startIcon={<Home />} onClick={() => navigate('/dashboard')}>
          Home
        </Button>
      </Stack>
    </Box>
  );
};

export default PageNotFound;
